var React = require('react');

function SearchDp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.90456 19.6239C11.9056 19.6239 13.7808 19.0255 15.3414 18.0031L20.8537 23.4764C21.2187 23.8255 21.6843 24 22.1877 24C23.2323 24 24 23.1896 24 22.1673C24 21.6935 23.8364 21.2322 23.484 20.8831L18.0094 15.4348C19.1421 13.839 19.8091 11.9065 19.8091 9.81195C19.8091 4.41351 15.354 0 9.90456 0C4.46775 0 0 4.41351 0 9.81195C0 15.2104 4.45517 19.6239 9.90456 19.6239ZM9.90456 17.0057C5.91505 17.0057 2.64289 13.7642 2.64289 9.81195C2.64289 5.85974 5.91505 2.61818 9.90456 2.61818C13.8941 2.61818 17.1662 5.85974 17.1662 9.81195C17.1662 13.7642 13.8941 17.0057 9.90456 17.0057Z","fill":"white"}));
}

SearchDp.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = SearchDp;

SearchDp.default = SearchDp;
